var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5543_30477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18738 16.4189C3.18738 13.171 5.82039 10.5379 9.06838 10.5379C12.3164 10.5379 14.9494 13.171 14.9494 16.4189M12.6543 4.81177C12.6543 6.80154 11.0413 8.41456 9.0515 8.41456C7.06174 8.41456 5.44871 6.80154 5.44871 4.81177C5.44871 2.82201 7.06174 1.20898 9.0515 1.20898C11.0413 1.20898 12.6543 2.82201 12.6543 4.81177Z",
    stroke: "currentColor",
    strokeWidth: 1.3833,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5543_30477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.444,
    height: 18.444,
    fill: "currentColor",
    transform: "translate(0.0664062 0.27832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e2e66554ec9257f9a18704aa504dadc5.svg";
export { ForwardRef as ReactComponent };